import { openBlock as l, createElementBlock as e, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#338AF3",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#F3F3F3",
  d: "M12.609 26.956H27.39L20 9.566l-7.392 17.39Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#333",
  d: "M15.178 25.217 20 14.247l4.823 10.97h-9.645Z"
}, null, -1), i = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "M12.609 26.956H27.39L20.001 20l-7.392 6.956Z"
}, null, -1), d = [
  n,
  s,
  c,
  i
];
function _(h, r) {
  return l(), e("svg", o, [...d]);
}
const f = { render: _ };
export {
  f as default,
  _ as render
};
